import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { UserContainerComponent } from './user/user.container.component';
import { UserDialogView } from './landing-page.modal';
import { CcdlDialogService, DialogRef } from '@cpm-pr1618001/ng-design-lib';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'landing-page-ui',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
  imports: [RouterOutlet, HeaderComponent],
  standalone: true,
})
export class LandingPageComponent implements OnChanges {
  @ViewChild('userDialogVCR', { read: ViewContainerRef })
  userDialogVCR: ViewContainerRef;

  @Input() userDialogView: UserDialogView;

  @Output() dialogOutsideClickEvent: EventEmitter<void> =
    new EventEmitter<void>();

  @Output() userDialogViewEventEmitter: EventEmitter<UserDialogView> =
    new EventEmitter<UserDialogView>();

  constructor(private ccdlDialogService: CcdlDialogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.userDialogView &&
      changes.userDialogView?.currentValue !==
        changes.userDialogView?.previousValue &&
      changes.userDialogView?.currentValue !== UserDialogView.CLOSE
    ) {
      this.openDialog();
    }
  }

  openDialog(): void {
    const dialogRef: DialogRef = this.ccdlDialogService.open(
      UserContainerComponent,
      {
        vcr: this.userDialogVCR,
      }
    );
    dialogRef.result.catch((data: boolean) => {
      this.dialogOutsideClickEvent.emit();
    });
  }

  userDialogViewEvent(event: UserDialogView) {
    this.userDialogViewEventEmitter.emit(event);
  }
}
